import React, { useState } from 'react';
import { doc, setDoc, deleteDoc } from 'firebase/firestore';
import { db } from '../../firebase';
import { useCollection } from '../../hooks/useCollection';
import { slugify } from '../../utils/slugify';
import ImageUploader from './ImageUploader';

const EMPTY = {
  titulo: '', descripcionCorta: '', descripcionLarga: '',
  imagen: '', epigrafe: '', orden: 0,
};

const AdminRecomendaciones = () => {
  const { docs, loading } = useCollection('recomendaciones');
  const [editando, setEditando] = useState(null);
  const [form, setForm] = useState(EMPTY);
  const [guardando, setGuardando] = useState(false);

  const abrirNuevo = () => { setForm(EMPTY); setEditando('nuevo'); };
  const abrirEdicion = (r) => { setForm({ ...EMPTY, ...r }); setEditando(r.slug); };
  const cerrar = () => setEditando(null);

  const set = (field, val) => setForm(f => ({ ...f, [field]: val }));

  const guardar = async (e) => {
    e.preventDefault();
    setGuardando(true);
    const slug = editando === 'nuevo' ? slugify(form.titulo) : editando;
    await setDoc(doc(db, 'recomendaciones', slug), { ...form, slug });
    setGuardando(false);
    cerrar();
  };

  const eliminar = async (slug) => {
    if (!window.confirm('¿Eliminar esta recomendación?')) return;
    await deleteDoc(doc(db, 'recomendaciones', slug));
  };

  if (loading) return <p>Cargando...</p>;

  if (editando) return (
    <form className="admin-form" onSubmit={guardar}>
      <h2>{editando === 'nuevo' ? 'Nueva recomendación' : 'Editar recomendación'}</h2>

      <label>Título *</label>
      <input value={form.titulo} onChange={e => set('titulo', e.target.value)} required />

      <label>Descripción corta *</label>
      <textarea value={form.descripcionCorta} onChange={e => set('descripcionCorta', e.target.value)} rows={3} required />

      <label>Descripción larga</label>
      <textarea value={form.descripcionLarga} onChange={e => set('descripcionLarga', e.target.value)} rows={10} />

      <label>Imagen</label>
      <ImageUploader folder="recomendaciones" currentUrl={form.imagen} onUpload={url => set('imagen', url)} />
      <input value={form.imagen} onChange={e => set('imagen', e.target.value)} placeholder="URL o ruta de la imagen" />

      <label>Epígrafe de la imagen (opcional)</label>
      <input value={form.epigrafe} onChange={e => set('epigrafe', e.target.value)} />

      <label>Orden de aparición (menor = primero)</label>
      <input type="number" value={form.orden} onChange={e => set('orden', Number(e.target.value))} />

      <div className="admin-form-actions">
        <button type="submit" className="admin-btn admin-btn-primary" disabled={guardando}>
          {guardando ? 'Guardando...' : 'Guardar'}
        </button>
        <button type="button" className="admin-btn" onClick={cerrar}>Cancelar</button>
      </div>
    </form>
  );

  return (
    <div>
      <div className="admin-section-header">
        <h2>Recomendaciones</h2>
        <button className="admin-btn admin-btn-primary" onClick={abrirNuevo}>+ Nueva recomendación</button>
      </div>
      <table className="admin-table">
        <thead>
          <tr><th>Orden</th><th>Título</th><th></th></tr>
        </thead>
        <tbody>
          {docs.map(r => (
            <tr key={r.id}>
              <td>{r.orden}</td>
              <td>{r.titulo}</td>
              <td className="admin-table-actions">
                <button className="admin-btn" onClick={() => abrirEdicion(r)}>Editar</button>
                <button className="admin-btn admin-btn-danger" onClick={() => eliminar(r.slug)}>Eliminar</button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default AdminRecomendaciones;
